import React from 'react';
import EmbedInteractModal from 'Components/Interact/EmbedInteractModal';
import { RoutePaths } from 'Interfaces/RoutePaths';
import { GuestWrapper } from 'Layouts/GuestWrapper';
import SimplifiedWrapper from 'Layouts/SimplifiedWrapper';
import { LoadingUserScreen } from 'Pages/AppSumo';
import {
  ConfirmEmail,
  ForgotPassword,
  LandingPageUploader,
  LandingSignUpConfirm,
  LandingSignUpWrapper,
} from 'Pages/Auth';
import { LandingSignUpThanks } from 'Pages/Auth/LandingSignUp/components';
import { DocumentActivitiesDownload } from 'Pages/DocumentActivitiesDownload';
import { DocumentDownload } from 'Pages/DocumentDownload';
import { UnlinkRemindersPage } from 'Pages/Documents';
import { DocumentSign } from 'Pages/DocumentSign';
import FormRequestShow from 'Pages/FormRequests/FormRequestShow';
import { InvoiceDownload } from 'Pages/InvoiceDownload';
import { InviteAcceptPage } from 'Pages/Team';

const BaseRoutes = [
  { path: RoutePaths.APPSUMO_THANKS, element: <LoadingUserScreen /> },
  {
    path: RoutePaths.RESET,
    element: <SimplifiedWrapper />,
    children: [{ index: true, element: <ForgotPassword /> }],
  },
  {
    path: RoutePaths.CONFIRM_EMAIL,
    element: <SimplifiedWrapper />,
    children: [{ index: true, element: <ConfirmEmail /> }],
  },
  {
    path: RoutePaths.ACCEPT_INVITE,
    element: <SimplifiedWrapper />,
    children: [{ index: true, element: <InviteAcceptPage /> }],
  },
  {
    path: RoutePaths.REMINDERS_UNLINK,
    element: <SimplifiedWrapper />,
    children: [{ index: true, element: <UnlinkRemindersPage /> }],
  },
  {
    path: RoutePaths.DOCUMENT_SIGN,
    element: <GuestWrapper />,
    children: [{ index: true, element: <DocumentSign /> }],
  },
  {
    path: RoutePaths.EMBED_DOCUMENT,
    element: <GuestWrapper />,
    children: [{ index: true, element: <EmbedInteractModal /> }],
  },
  // Embedded interact modal was a component route in BaseRoutes; keep path for future use if needed
  {
    path: RoutePaths.DOCUMENT_DOWNLOAD,
    element: <DocumentDownload />,
  },
  { path: RoutePaths.ORIGINAL_DOCUMENT_DOWNLOAD, element: <DocumentDownload /> },
  { path: RoutePaths.SEPARATED_DOCUMENT_DOWNLOAD, element: <DocumentDownload /> },
  {
    path: RoutePaths.DOCUMENT_ACTIVITIES_DOWNLOAD,
    element: <DocumentActivitiesDownload />,
  },
  { path: RoutePaths.SIGNER_DOCUMENT_DOWNLOAD, element: <DocumentDownload /> },
  { path: RoutePaths.INVOICE_DOWNLOAD, element: <InvoiceDownload /> },
  {
    path: RoutePaths.FORM_REQUESTS_SEND,
    element: <GuestWrapper isShowFooter={false} isShowHeaderBorder={true} />,
    children: [{ index: true, element: <FormRequestShow /> }],
  },
  { path: RoutePaths.LANDING_SIGNUP, element: <LandingSignUpWrapper /> },
  { path: RoutePaths.LANDING_DOCUMENT_UPLOADER, element: <LandingPageUploader /> },
  { path: RoutePaths.LANDING_DOCUMENT_EDITOR, element: <LandingSignUpWrapper /> },
  { path: RoutePaths.LANDING_SIGNUP_CONFIRM, element: <LandingSignUpConfirm /> },
  { path: RoutePaths.LANDING_SIGNUP_THANKS, element: <LandingSignUpThanks /> },
];

export default BaseRoutes;
